export default __webpack_public_path__ + "static/college-35d3098ddd6e51ce71cc906cefd1faa4.png";